<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="ContentMargin">
        <div>
          <div class="content_head">
            <div class="content_head_ico">
              <img src="@/assets/images/estorage/content_title_ico_blue.png" alt=""/>
            </div>
            <div class="content_head_title">
              质检模板
            </div>
            <div class="content_head_button">
              <!-- <div class="content_head_seek">
                <lk-button img="add.png" @click="QCDetails('新增')">新增</lk-button>
              </div> -->
              <div class="content_head_seek">
                <el-input placeholder="输入质检模板名称" v-model="queryCheckNumber" class="input-with-select">
                  <el-button slot="append" icon="el-icon-search" @click="getQCList(1)"></el-button>
                </el-input>
              </div>
            </div>
          </div>
          <div class="Notice_list">
            <el-table :data="QCTemplate" style="width: 100%">
              <el-table-column prop="grainVariety" label="粮食品种" align="center"/>
              <el-table-column prop="QCTemplateID" label="质检模板编码" align="center"/>
              <el-table-column prop="QCTemplateName" label="质检模板名称" align="center"/>
              <el-table-column prop="QCTemplatePType" label="质检模板类型" align="center"/>
              <el-table-column prop="QCTemplateStateCn" label="质检模板状态" align="center"/>
              <el-table-column prop="description" label="描述" align="center" width="250"/>
              <el-table-column prop="addTime" label="添加时间" align="center"/>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="QCDetails('明细',scope.row)">明细</el-button>
                  <!-- <el-button type="text" size="small" @click="QCDetails('编辑',scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click="QCDetails('删除',scope.row)" style="color: red">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!-- 分页器-->
          <div class="paging">
            <div class="block">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next, jumper"
                :total="totalQuantity">
              </el-pagination>
            </div>
          </div>
          <!--        新增，详细，编辑弹窗-->
          <el-dialog
            :title="dialogTitle"
            :visible.sync="redactShow"
            width="30%"
            style="margin-top: 5vh"
          >
            <div class="dialog_content" v-if="dialogTitle === '明细'">
              <el-table :data="mx" style="width: 100%" height="400">
                <el-table-column prop="grKindCn" label="粮食品种" align="center"/>
                <el-table-column prop="type" label="质检模板类型" align="center"/>
                <el-table-column prop="chItemCn" label="质检项" align="center"/>
                <!-- <el-table-column prop="denyLowerLi" label="标准下限" align="center" width="90"/>
                <el-table-column prop="denyUpperLi" label="标准上限" align="center" width="90"/> -->
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" @click="$refs.setDialogRef.showDialog(scope.row)">设置</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="dialog_content" v-else>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>粮食品种:</span>
                <Treeselect
                  v-if="dialogTitle=='新增'||dialogTitle=='编辑'"
                  :disabled="dialogTitle==='编辑'"
                  v-model="grainVariety"
                  :options="grainVarietyList"
                  placeholder="请选择"
                  :disable-branch-nodes="true"
                />
                <el-input v-else v-model="grainVariety" placeholder="请输入粮食品种" disabled></el-input>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检模板编码:</span>
                <el-input v-model="QCTemplateID" placeholder="质检模板编码" :disabled="dialogTitle!=='新增'"></el-input>
              </div>
              <div class="dialog_content_c">
                <span>质检模板名称:</span>
                <el-input v-model="QCTemplateName" placeholder="质检模板名称" :disabled="dialogTitle!=='新增'"></el-input>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检模板类型:</span>
                <el-select v-model="QCTemplateType" placeholder="请选择" @change="changeType()" :disabled="dialogTitle!=='新增'">
                  <el-option
                    v-for="item in QCTemplateTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c" v-show="secondOpen">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>库存质检子类:</span>
                <el-select v-model="QCTemplateType1" placeholder="请选择" :disabled="dialogTitle!=='新增'">
                  <el-option
                    v-for="item in QCTemplateTypeList1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span><span style="color:red;padding-right:0;width:auto;">*</span>质检模板状态:</span>
                <el-select v-model="QCTemplateState" placeholder="请选择" :disabled="dialogTitle!=='新增'&&dialogTitle!=='编辑'">
                  <el-option
                    v-for="item in QCTemplateStateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="dialog_content_c">
                <span>描述:</span>
                <el-input v-model="description" type="textarea" placeholder="描述" :disabled="dialogTitle!=='新增'&&dialogTitle!=='编辑'"></el-input>
              </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="redactShow = false">取消</el-button>
              <el-button type="primary" @click="upQCDate()" v-if="dialogTitle==='新增'">保存</el-button>
              <el-button type="primary" @click="upQCDate(2)" v-if="dialogTitle==='编辑'">保存</el-button>
              <el-button type="danger" @click="QCDelete" v-if="dialogTitle==='删除'">删除</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
    <setDialog ref="setDialogRef" @emit="redactShow = false"></setDialog>
  </div>
</template>

<script>
import {getdatadirid,getdatadirid_allsons} from "@/utils/util";
import {httpToken} from '@/utils/http'
import qs from 'qs'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import setDialog from "./Temp/set.vue"
export default {
  name: 'Temp',
  components: { Treeselect,setDialog },
  data() {
    return {
      QCTemplate: [],
      ids: '',
      grainVariety: null,
      QCTemplateID: '',
      QCTemplateName: '',
      QCTemplateType: '',
      //二级模板类型
      QCTemplateType1: '',
      QCTemplateState: '',
      QCTemplateStateCn: '',
      description: '',
      addTime: '',
      mx:[],//明细数据
      QCListALL: [],
      grainVarietyList: [],// 粮食品种
      QCTemplateTypeList: [],
      //二级模板类型
      QCTemplateTypeList1: [],
      secondOpen: false,
      QCTemplateStateList: [
        {
          value: 0,
          label: '启用'
        },
        {
          value: 1,
          label: '未用'
        }
      ],
      currentPage: 1,
      totalQuantity: 10,
      queryCheckNumber: '',
      redactShow: false,
      dialogTitle: '',
      current: 1
    }
  },
  methods: {
    // 修改
    upQCDate(type=1) {
      if (this.grainVariety == null) {
        this.$message({
          message: '请选择粮食品种',
          type: 'error'
        })
      } else if (this.QCTemplateType === '') {
        this.$message({
          message: '请选择质检模板类型',
          type: 'error'
        })
      } else if (this.secondOpen && this.QCTemplateType1 === '') {
        this.$message({
          message: '请选择库存质检子类',
          type: 'error'
        })
      } else if (this.QCTemplateState === '') {
        this.$message({
          message: '请选择质检模板状态',
          type: 'error'
        })
      } else {
        let Data = {
          // id: this.ids,
          grKindId: this.grainVariety,
          mouldCode: this.QCTemplateID,
          mouldName: this.QCTemplateName,
          mouldStatus: this.QCTemplateState,
          mouleDescribe: this.description
        }
        if (this.secondOpen) {
          Data['mouldTypeP'] = this.QCTemplateType
          Data['mouldType'] = this.QCTemplateType1
        } else {
          Data['mouldTypeP'] = this.QCTemplateType
        }
        let url=''
        if(type===1){
          url='/mould/save'
        }else{
          url='/mould/update'
          Data.id=this.ids
        }
        httpToken({
          url: url,
          method: 'post',
          data: Data
        }).then(res => {
          this.redactShow = false
          if (res.data.code === 200) {
            this.getQCList(this.current)
          }
        })
      }
    },
    // 获取质检项数据
    getQCList(page) {
      let paramData = [{column: "id", type: '', value: ''},{ column: "create_date", type: "orderByDesc"}]
      if (this.queryCheckNumber) {
        paramData.push({column: "mould_name", type: 'like', value: this.queryCheckNumber})
      }
      httpToken({
        url: '/mould/list',
        method: 'post',
        data: qs.stringify({
          paramData: JSON.stringify(paramData),
          page: page
        })
      }).then(res => {
        if(page!==res.data.data.current){
          getdatalb(res.data.data.current)
          return
        }
        const QCALL = res.data.data
        this.QCTemplate = []
        for (let q = 0; q < QCALL.records.length; q++) {
          const QC = QCALL.records[q]
          if (QC.mouldStatus === 0) {
            QC.mouldStatusCn = '启用'
          } else {
            QC.mouldStatusCn = '未用'
          }
          this.QCTemplate.push({
            ids: String(QC.id) ,
            grainVariety: QC.grKindCn,
            grKindId:QC.grKindId,
            QCTemplateID: QC.mouldCode,
            QCTemplateName: QC.mouldName,
            mouldType:QC.mouldType,
            QCTemplateType: QC.mouldTypeCn,
            mouldTypeP:QC.mouldTypeP,
            mouldTypePCn:QC.mouldTypePCn,
            QCTemplatePType: QC.mouldType==QC.mouldTypeP?QC.mouldTypePCn||'无':QC.mouldTypePCn||'无'+'/'+QC.mouldTypeCn||'无',
            QCTemplateState: QC.mouldStatus,
            QCTemplateStateCn: QC.mouldStatusCn,
            description: QC.mouleDescribe,
            addTime: QC.createDate.replace('T', ' '),
          })
        }
        this.totalQuantity = QCALL.total
        this.currentPage = page
        this.current = page;
      })
    },
    // 详情和编辑和新增按键
    QCDetails(val, state) {
      this.dialogTitle = val
      if (state) {
        this.ids = state.ids
        if (val == "明细") {
          this.mx = [];
          let paramData = [
            {
              column: "ch_mo_cn",
              type: "like",
              value: state.QCTemplateName,
            },
          ];
          httpToken({
            url: "/mouldDetail/list",
            method: "post",
            data: qs.stringify({
              paramData: JSON.stringify(paramData),
              page: 1,
              rows: 100,
            }),
          }).then((res) => {
            this.mx = res.data.data.records;
            this.redactShow = true
          });
        }else if(val=='编辑'){
          this.grainVariety = state.grKindId||null
          this.QCTemplateType = state.mouldTypeP
          this.QCTemplateType1 = state.mouldType
          this.redactShow = true
        }else{
          this.grainVariety = state.grainVariety||null
          this.QCTemplateType = state.QCTemplatePType
          this.QCTemplateType1 = state.QCTemplateType
          this.redactShow = true
        }
        this.secondOpen = state.mouldTypePCn === '库存鉴定';
        this.QCTemplateID = state.QCTemplateID
        this.QCTemplateName = state.QCTemplateName
        this.QCTemplateState = state.QCTemplateState
        this.QCTemplateStateCn = state.QCTemplateStateCn
        this.description = state.description
      } else {
        this.ids = ''
        this.grainVariety = null
        this.QCTemplateID = ''
        this.QCTemplateName = ''
        this.QCTemplateType = ''
        this.QCTemplateState = ''
        this.description = ''
        this.redactShow = true
      }
    },
    // 删除质检项信息
    QCDelete() {
      httpToken({
        url: '/mould/delete',
        method: 'post',
        data: qs.stringify({ids: this.ids})
      }).then(res => {
        if (res.data.code === 200) {
          this.redactShow = false
          this.getQCList(this.current)
        }
      })
    },
    // 查找二级化验类型
    changeType() {
      let typeName = ''
      this.QCTemplateTypeList.forEach((item) => {
        if (this.QCTemplateType === item.value) {
          typeName = item.label
        }
      })
      this.QCTemplateType1 = ''
      this.secondOpen = typeName === '库存鉴定';
    },
    // 切换页码
    handleCurrentChange(val) {
      this.getQCList(val)
    }
  },
  mounted() {
    this.getQCList(1)
    getdatadirid_allsons('grainKind').then(res=>{
      this.grainVarietyList =res
    })
    this.QCTemplateTypeList = getdatadirid('qualityTempType', 1)
    this.QCTemplateTypeList1 = getdatadirid('Testtype', 1)
  }
}
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

::v-deep .vue-treeselect--disabled{
  .vue-treeselect__control{
    .vue-treeselect__single-value{
      color: #000 !important;
    }
    background-color: #fff !important;
  }
  cursor: not-allowed;
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #F5F8FF;
  }

  ::v-deep .el-table thead {
    color: #000000
  }
}

.dialog_content {
  //margin-bottom: 30px;

  p {
    margin-bottom: 10px;
  }

  .dialog_content_c {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    span {
      text-align: right;
      width: 30%;
      padding-right: 10px;
    }
    .el-select {
      width: 60%;
      margin: auto 0;
    }

    .el-input {
      width: 60%;
      margin: auto 0;
    }

    .el-textarea {
      width: 60%;
      margin: auto 0;
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
// 树形下拉样式修改
::v-deep .vue-treeselect{
  width: 60%;
  margin: auto 0;
  height: 40px;
}
::v-deep .vue-treeselect__control{
  height: 40px;
  .vue-treeselect__single-value{
    line-height: 40px;
  }
}
::v-deep .vue-treeselect--disabled .vue-treeselect__control{
  background-color: #F5F7FA;
  border-color: #E4E7ED;
  .vue-treeselect__single-value{
    color: #C0C4CC;
  }
}
::v-deep .vue-treeselect__placeholder{
  line-height: 40px;
}
</style>
